import { render, staticRenderFns } from "./design-studio-builder-widget.vue?vue&type=template&id=fecd1ed4&"
import script from "./design-studio-builder-widget.vue?vue&type=script&lang=js&"
export * from "./design-studio-builder-widget.vue?vue&type=script&lang=js&"
import style0 from "./design-studio-builder-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports